import 'element-closest-polyfill'

require("@rails/ujs").start()
require("@rails/activestorage").start()

require("jquery")
require("konva")

import Swal from 'sweetalert2'
global.Swal = Swal

import "materialize-css/dist/js/materialize"

import "./sidenav"
import "./buildings"
import "./email_templates"
import "./qrcode"
import "./inquiries"
import "./properties"
import "./contact_settings"
import "./propertyCsvSettings"
import "./office_viewing_settings"
import "./viewings"
import "./viewing_email_settings"

import "./flatpickr"

import "./vue-renderer"

import "../stylesheets/application.scss"

$(document).ready(function(){
  $(".dropdown-trigger").dropdown({ coverTrigger: false })
  $('.sidenav').sidenav()
  $('.modal').modal()
  $('.tabs').tabs()
  $("select:not(.flatpickr-monthDropdown-months)").formSelect()
})
